/* eslint-disable react/no-array-index-key */
import classnames from 'classnames';
import React, { FC } from 'react';

export interface GenericSpinnerProps {
    className?: string;
    ariaLabel: string;
    mini?: boolean;
    colors: string[];
    stroke?: string;
    strokeWidth?: number;
    roundedEdges: boolean;
}

const GenericSpinner: FC<GenericSpinnerProps> = ({
    className,
    ariaLabel,
    mini,
    colors,
    stroke,
    strokeWidth = 5,
    roundedEdges,
}) => {
    return (
        <div
            className={classnames('sgw-loader', className, { 'loader--mini': mini })}
            role="status"
            aria-label={ariaLabel}
        >
            <svg viewBox="-25 -25 50 50" width="100%" className="spin">
                {stroke && <circle stroke={stroke} fill="none" cx="0" cy="0" r={22} strokeWidth={strokeWidth + 1} />}
                {colors.map((color, index) => (
                    <path
                        key={color + index}
                        style={{ fill: 'none', stroke: color }}
                        d={`M ${Math.cos((2 * Math.PI * (index - 1)) / colors.length) * 22} ${Math.sin((2 * Math.PI * (index - 1)) / colors.length) * 22} A 22 22 0 0 1 ${Math.cos((2 * Math.PI * index) / colors.length) * 22} ${Math.sin((2 * Math.PI * index) / colors.length) * 22} `}
                        strokeWidth={strokeWidth}
                    />
                ))}
                {roundedEdges &&
                    colors.map((color, index) => (
                        <circle
                            key={color + index}
                            style={{ fill: color }}
                            cx={Math.cos((2 * Math.PI * index) / colors.length) * 22}
                            cy={Math.sin((2 * Math.PI * index) / colors.length) * 22}
                            r="2.5"
                            strokeWidth="0"
                        />
                    ))}
            </svg>
        </div>
    );
};

export default GenericSpinner;
